export interface ScanEvent {
    type: ScanEventType,
    value?: number
}

export enum ScanEventType {
    none = 0,
    indexChange,
    cycleComplete
}